import { useEffect } from "react";

export default function useClickAway(ref, onClose) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)){
                onClose();
            }
                
        }
        document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onClose]);
}